import React, {Component} from 'react';
import { Form, Checkbox } from 'semantic-ui-react'
import PropTypes from 'prop-types';
class NewsStatoSelect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fields: {
                visibile: props.isVisibile,
            }
        };
        this.onTipoChange = this.onTipoChange.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            fields: {
                visibile: nextProps.isVisibile,
            }
        })
    }

    onTipoChange(a1, {name, checked}){
        let fields = this.state.fields;
        fields[name] = checked;
        this.setState({fields})
        this.props.onChange(fields.visibile);
    }

    render() {
        return (
        <div className="ui stackable form">
            <Form.Group widths="1">
                <Form.Field inline >
                    <Checkbox label="Notizie visibili" name="visibile" toggle checked={this.state.fields.visibile} onChange={this.onTipoChange} />
                </Form.Field>
            </Form.Group>
        </div>)
    }
}

NewsStatoSelect.PropTypes = {
    isVisibile: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
};

NewsStatoSelect.defaultProps = {
    isVisibile: true,
};
export default NewsStatoSelect;




/** WEBPACK FOOTER **
 ** ./src/components/news/NewsStatoSelect.js
 **/